import { useState } from 'react';
import './App.css';

function App() {
  const [search, setSearch] = useState('');
  const [movies, setMovies] = useState([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [selectedMovie, setSelectedMovie] = useState(null);

  const API_KEY = 'b1737874';

  async function searchMovies() {
    if (search === '') {
      setError('Please enter a movie name!');
      return;
    }
    setLoading(true);
    setError('');
    try {
      const response = await fetch(`https://www.omdbapi.com/?s=${search}&apikey=${API_KEY}`);
      const data = await response.json();
      if (data.Response === 'False') {
        setError('No movies found!');
        setMovies([]);
      } else {
        setMovies(data.Search);
      }
    } catch (err) {
      setError('Something went wrong!');
    }
    setLoading(false);
  }

  async function getMovieDetails(imdbID) {
    const response = await fetch(`https://www.omdbapi.com/?i=${imdbID}&apikey=${API_KEY}`);
    const data = await response.json();
    setSelectedMovie(data);
  }

  return (
    <div className="app">
      <div className="header">
        <h1>🎬 Movie Search</h1>
        <p>Search for any movie in the world!</p>
      </div>

      <div className="search">
        <input
          type="text"
          placeholder="Search for a movie..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          onKeyPress={(e) => e.key === 'Enter' && searchMovies()}
        />
        <button onClick={searchMovies}>Search</button>
      </div>

      {error && <p className="error">{error}</p>}
      {loading && <p className="loading">Searching...</p>}

      <div className="movies-grid">
        {movies.map((movie) => (
          <div className="movie-card" key={movie.imdbID} onClick={() => getMovieDetails(movie.imdbID)}>
            <img
              src={movie.Poster !== 'N/A' ? movie.Poster : 'https://via.placeholder.com/300x450?text=No+Poster'}
              alt={movie.Title}
            />
            <div className="movie-info">
              <h3>{movie.Title}</h3>
              <p>{movie.Year}</p>
              <span>{movie.Type}</span>
            </div>
          </div>
        ))}
      </div>

      {selectedMovie && (
        <div className="modal-overlay" onClick={() => setSelectedMovie(null)}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <button className="close-btn" onClick={() => setSelectedMovie(null)}>✕</button>
            <div className="modal-content">
              <img
                src={selectedMovie.Poster !== 'N/A' ? selectedMovie.Poster : 'https://via.placeholder.com/300x450?text=No+Poster'}
                alt={selectedMovie.Title}
              />
              <div className="modal-info">
                <h2>{selectedMovie.Title}</h2>
                <p className="year">📅 {selectedMovie.Year} • {selectedMovie.Rated}</p>
                <p className="rating">⭐ {selectedMovie.imdbRating}/10</p>
                <p className="genre">🎭 {selectedMovie.Genre}</p>
                <p className="director">🎬 {selectedMovie.Director}</p>
                <p className="actors">👥 {selectedMovie.Actors}</p>
                <p className="plot">{selectedMovie.Plot}</p>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;
